"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
function default_1() {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { children: [`■ ${i18next_1.default.t('저작권')}`, (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('본 작업물의 저작권은 저에게(@ ) 있습니다'), "."] }), (0, jsx_runtime_1.jsx)("p", { children: "\u00A0" }), (0, jsx_runtime_1.jsxs)("p", { children: [`■ ${i18next_1.default.t('주의사항')}`, (0, jsx_runtime_1.jsx)("br", {}), ` • ${i18next_1.default.t('허가받지 않은 2차 가공, 상업적 이용을 금지합니다')}.`] })] }));
}
exports.default = default_1;
